// TSS vite/04 §"Endpoint paths".
// No leading slash — axios joins baseURL + url with a single slash.
//
// The three lists this feature reads besides its own: the owner of a token is
// a person, the repository it names lives in a project, and `/admin/repositories`
// does NOT take `?q=` — it takes `?project_id=`. That is why the form asks for
// the project first: it is the only filter the backend gives to narrow the
// repositories, and picking from nine hundred without one is not picking.
export const tokenPaths = {
    list:   () => 'admin/tokens',
    detail: (id) => `admin/tokens/${id}`,
    users:        () => 'admin/users',
    projects:     () => 'admin/projects',
    repositories: () => 'admin/repositories',
};
